import React from 'react';
import SuiResultUrl from '../SuiResultUrl/SuiResultUrl';

import './TitleLink.css';

const TitleLink = ({ url, cleanTitle, onClickLink }) => {
  return (
    <>
      <h3 className="sui-result__title-link" style={{ margin: '2px' }}>
        {url ? (
          <a onClick={onClickLink} href={url}>
            {cleanTitle}
          </a>
        ) : (
          cleanTitle
        )}
      </h3>
      {!url.includes('pdf') && !url.includes('PDF') && <SuiResultUrl url={url} />}
    </>
  );
};

export default TitleLink;
